<template>
    <div>
        <b-card>
            <div slot="header">
                <i class="fa fa-list-ul" aria-hidden="true"></i>
                    {{text.serviceRequestList}}
                <div class="card-header-actions">
                    <a href="https://bootstrap-vue.js.org/docs/components/progress" class="card-header-action" rel="noreferrer noopener" target="_blank">
                    <small class="text-muted">{{text.docs}}</small>
                    </a>
                </div>
            </div>
            <b-row>
                <b-col sm="12">
                    <alert-fail :show="'' !== errorMessage"> {{ errorMessage }} </alert-fail>
                    <b-row>
                      <b-col cols="2" md="1">
                          <b-form-group
                          :label="text.filter"
                          >
                          </b-form-group>
                      </b-col>
                      <b-col cols="7" md="8" class="magin-minus-top-5">
                          <b-input v-model="filter.text" :placeholder="text.pleaseEnterFilter"></b-input>
                      </b-col>
                      <b-col cols="3" md="3" class="magin-minus-top-5">
                          <v-select :clearable="false" v-model="filter.status" class="users-filter" :options="['all', 'pending', 'closed']" :placeholder="'filter type'"></v-select>
                      </b-col>
                    </b-row>
                    <b-table
                          stacked="sm"
                          :busy="isBusy"
                          :current-page="currentPage"
                          :per-page="numberPerPage"
                          class="table-privilege"
                          tbody-class="tbody" hover
                          thead-tr-class="thead-news"
                          @row-clicked="viewDetails"
                          selectedVariant="single"
                          selectable
                          :filter="filter.text"
                          :fields="fields"
                          :items="list">
                          <template slot="thumbnail" slot-scope="row">
                            <img class="thumbnail" :src="row.item.thumbnail" alt="Thumbnail">
                          </template>
                          <template slot="active" slot-scope="row">
                              <font style="color: #f86c6b" v-if="row.item.active">Inactive</font>
                              <font style="color: #4dbd74" v-else>Active</font>
                          </template>
                            <div slot="table-busy" class="text-center text-dark my-2">
                                <b-spinner variant="dark" class="align-middle"></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                    </b-table>
                    <hr/>
                    <b-row>
                        <b-pagination
                        class="pagination my-0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="numberPerPage"
                        ></b-pagination>
                    </b-row>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import AlertFail from '../../../components/alert/AlertFail';
import { dateToStringWithTimeFull } from '../../../assets/utils/time';
import vSelect from 'vue-select';
import { ProjectList } from '../../../models/project-list';
import MqdcOneClient from '../../../models/mqdc-one-client';
import { textServiceRequest } from '@/assets/utils/language';

export default {
  data () {
    return {
      errorMessage: '',
      isBusy: false,
      currentPage: 1,
      numberPerPage: 20,
      fields: [
        { key: 'email' },
        { key: 'type' },
        { key: 'timeRequest' },
        { key: 'caseNumber' },
        { key: 'status' }
      ],
      list: [
        // { time: '10 September 2019, 23:27:48', status: 'on progress', caseNumber: 'ไฟดับ', email: 'mikarukinji@gmail.com' }
      ],
      filter: {
        text: '',
        project: '',
        status: 'all'
      },
      delay: { time: 1000, interval: null },
      projectList: [],
      mqdcOneClient: {},
      text: {}
    };
  },
  methods: {
    viewDetails (e) {
      window.open(this.$router.resolve({ name: 'requestLanding', params: { id: e.token } }).href, '_blank');
    },
    getData () {
      this.isBusy = true;
      this.list = [];
      this.mqdcOneClient.getAxios().then(axios => {
        axios.get(process.env.VUE_APP_URL_MQDCONE_API + `/mqdc-one/service-requests-management?currentPage=${this.currentPage}&perPage=30&projectCode=${this.projectList.map(p => p.code).join(',')}&status=${'all' === this.filter.status ? '' : this.filter.status}`)
          .then(response => {
            const data = response.data.data;
            if (data) {
              for (const sr of data) {
                this.list.push({
                  token: sr.token,
                  email: sr.user.email,
                  type: sr.careService.type,
                  timeRequest: dateToStringWithTimeFull(new Date(sr.createdAt.timestamp * 1000)),
                  caseNumber: sr.caseNo,
                  status: sr.status
                });
              }
            }
          })
          .catch(error => {
            this.errorMessage = error.response ? error.response.data : error.message;
          })
          .finally(() => {
            this.isBusy = false;
          });
      });
    },
    refreshFields () {
      this.fields = [
        { key: 'email', label: this.text.email },
        { key: 'type', label: this.text.type },
        { key: 'timeRequest', label: this.text.timeRequest },
        { key: 'caseNumber', label: this.text.caseNumber },
        { key: 'status', label: this.text.status }
      ];
    }
  },
  computed: {
    totalRows () {
      return this.list.length;
    }
  },
  components: {
    AlertFail,
    'v-select': vSelect
  },
  watch: {
    'filter.status' () {
      this.getData();
    },
    $language: function () {
      this.text = textServiceRequest(this.$language);
      this.refreshFields();
    }
  },
  mounted () {
    this.mqdcOneClient = new MqdcOneClient(this.axios);
    this.projectList = (new ProjectList()).getProjectSelectDrobdownObject();
    this.getData();
    this.text = textServiceRequest(this.$language);
    this.refreshFields();
  }
};
</script>

<style scoped>
  .thumbnail{
        max-width: 100px;
    }
  .magin-minus-top-5{
      margin-top: -5px
  }
</style>
<style>
    .pagination {
        margin-left: auto;
        margin-right: auto;
    }
    .users-filter .vs__search::placeholder,
    .users-filter .vs__dropdown-toggle,
    .users-filter .vs__dropdown-menu {
        color: #394066;
        font-variant: small-caps;
        border: 1px solid #e4e7ea;
    }
    .filter-status {
        margin-top: 1px;
    }
</style>
